// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__1X1T1","checkMarkContainer":"Checkbox_checkMarkContainer__1LSgR","checkMark":"Checkbox_checkMark__30mXX"};